import React from "react";
// eslint-disable-next-line no-restricted-imports -- TODO: update to `next/navigation` before using this component in App Router
import { useRouter } from "next/router";

import MetaTags from "components/MetaTags";

import useFilters from "../../hooks/useFilters";

export type Props = {
  description?: string;
  title?: string;
};

const StrainListHead: React.FunctionComponent<Props> = ({
  description,
  title,
}: Props) => {
  const {
    query: { page = 1, name: pageName = "", sort },
  } = useRouter();

  const { filtersApplied } = useFilters();

  const metaDescription =
    description ||
    "Browse the most comprehensive marijuana strain database on the web! Read strain reviews, discover new strains, and learn more about your favorites.";
  const metaTitle = title || `${pageName} marijuana strains | Leafly`;

  return (
    <MetaTags
      description={`${metaDescription}${
        Number(page) > 1 ? ` Page ${page}.` : ""
      }`}
      title={`${metaTitle}${Number(page) > 1 ? ` | page ${page}` : ""}`}
      canonicalParams={["page"]}
      image="https://public.leafly.com/web-strain-explorer/explore-og-image.png"
      robots={filtersApplied || sort ? "noindex" : undefined}
    />
  );
};

export default StrainListHead;
